class BannerSlider {
  constructor(el) {
    this.el = el;
    this.slides = Array.from(el.querySelectorAll('.banner-slider__slide'));
    this.dots = Array.from(el.querySelectorAll('.banner-slider__dot'));
    this.prevBtn = el.querySelector('.banner-slider__prev');
    this.nextBtn = el.querySelector('.banner-slider__next');
    this.pauseBtn = el.querySelector('.banner-slider__pause');

    this.current = 0;
    this.timer = null;
    this.progressRAF = null;
    this.isPaused = false;

    this.autoplay = el.dataset.autoplay === 'true';
    this.speed = parseInt(el.dataset.autoplaySpeed, 10) || 6000;

    if (this.slides.length <= 1) return;

    this.bindEvents();

    if (this.autoplay) {
      this.start();
    }

    this.el.addEventListener('mouseenter', () => {
      if (!this.isPaused) {
        this.stop();
      }
    });

    this.el.addEventListener('mouseleave', () => {
      if (this.autoplay && !this.isPaused) {
        this.start();
      }
    });
  }


  bindEvents() {

    // Next button
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.goTo(this.current + 1);
        this.restartIfRunning();
      });
    }


    // Previous button
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.goTo(this.current - 1);
        this.restartIfRunning();
      });
    }


    // Dots
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = Number(dot.dataset.gotoSlide);
        this.goTo(index);
        this.restartIfRunning();
      });
    });


    // Pause / Play button
    if (this.pauseBtn) {

      const playIcon = this.pauseBtn.querySelector('.icon-play');
      const pauseIcon = this.pauseBtn.querySelector('.icon-pause');

      // Initial state
      pauseIcon?.classList.add('active');
      playIcon?.classList.remove('active');


      this.pauseBtn.addEventListener('click', () => {

        this.isPaused = !this.isPaused;


        if (this.isPaused) {

          this.stop();

          pauseIcon?.classList.remove('active');
          playIcon?.classList.add('active');

          this.pauseBtn.setAttribute(
            'aria-label',
            'Play slideshow'
          );


        } else {

          this.start();

          playIcon?.classList.remove('active');
          pauseIcon?.classList.add('active');

          this.pauseBtn.setAttribute(
            'aria-label',
            'Pause slideshow'
          );

        }

      });

    }



    // Swipe support
    let touchStartX = 0;


    this.el.addEventListener(
      'touchstart',
      (e) => {
        touchStartX = e.touches[0].clientX;
      },
      { passive: true }
    );


    this.el.addEventListener(
      'touchend',
      (e) => {

        const touchEndX = e.changedTouches[0].clientX;

        const difference = touchStartX - touchEndX;


        if (Math.abs(difference) > 40) {

          if (difference > 0) {
            this.goTo(this.current + 1);
          } else {
            this.goTo(this.current - 1);
          }

          this.restartIfRunning();

        }

      },
      { passive: true }
    );

  }



  goTo(index) {

    const total = this.slides.length;

    this.current = (index + total) % total;


    this.slides.forEach((slide, i) => {

      slide.classList.toggle(
        'is-active',
        i === this.current
      );

    });


    this.dots.forEach((dot, i) => {

      dot.classList.toggle(
        'is-active',
        i === this.current
      );

    });

  }




  start() {

    this.stop();


    this.timer = setInterval(() => {

      this.goTo(this.current + 1);

      this.restartProgress();

    }, this.speed);


    this.restartProgress();

  }




  stop() {

    if (this.timer) {

      clearInterval(this.timer);

      this.timer = null;

    }


    if (this.progressRAF) {

      cancelAnimationFrame(this.progressRAF);

      this.progressRAF = null;

    }

  }




  restartProgress() {

    if (!this.pauseBtn) return;


    if (this.progressRAF) {

      cancelAnimationFrame(this.progressRAF);

    }


    const startTime = performance.now();

    const duration = this.speed;



    const update = (now) => {

      const elapsed = now - startTime;

      const percentage = Math.min(
        (elapsed / duration) * 100,
        100
      );


      this.pauseBtn.style.setProperty(
        '--progress',
        percentage + '%'
      );


      if (elapsed < duration) {

        this.progressRAF = requestAnimationFrame(update);

      }

    };


    this.progressRAF = requestAnimationFrame(update);

  }




  restartIfRunning() {

    if (this.autoplay && !this.isPaused) {

      this.start();

    }

  }

}




function initBannerSliders() {

  document
    .querySelectorAll('.banner-slider')
    .forEach((el) => {


      if (!el.dataset.initialized) {

        new BannerSlider(el);

        el.dataset.initialized = 'true';

      }


    });

}




if (document.readyState === 'loading') {

  document.addEventListener(
    'DOMContentLoaded',
    initBannerSliders
  );

} else {

  initBannerSliders();

}




// Shopify theme editor support
document.addEventListener(
  'shopify:section:load',
  (event) => {

    const slider = event.target.querySelector(
      '.banner-slider'
    );


    if (slider) {

      new BannerSlider(slider);

    }

  }
);